module.exports = __webpack_public_path__ + "static/media/Impact on California.47869e2c.pdf";